import { render } from "./StatsCard.vue?vue&type=template&id=635c3458"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/garay/code/omnichannel/dashboard-agente/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__